const DRAFT_STORAGE_KEY = "portfolio-content-draft";

export const loadDraftFromStorage = () => {
  if (typeof window === "undefined") return null;
  try {
    const raw = window.localStorage.getItem(DRAFT_STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const saveDraftToStorage = (draft) => {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(DRAFT_STORAGE_KEY, JSON.stringify(draft));
};

export const clearDraftFromStorage = () => {
  if (typeof window === "undefined") return;
  window.localStorage.removeItem(DRAFT_STORAGE_KEY);
};

/**
 * In development, prefer a saved draft overlay for entities that do not need
 * webpack image imports. Image-backed entities still require `npm run content:sync`.
 */
export const withDraftOverlay = (key, fallback) => {
  if (process.env.NODE_ENV !== "development") return fallback;
  const draft = loadDraftFromStorage();
  if (!draft || !Array.isArray(draft[key])) return fallback;
  return draft[key];
};
